TrelloModel = require 'models/internal/trello-model'

module.exports = class PluginData extends TrelloModel
  typeName: 'PluginData'

  urlRoot: ->
    "/1/#{ @get('scope') }/#{ @get('idModel') }/pluginData"



// WEBPACK FOOTER //
// ./app/scripts/models/plugin-data.coffee